import { h, JSX } from "@stencil/core";
import { dealerSearchResultsStore } from "@phn/state/dealer-search-results-store";
import {
  ClickElementTypes,
  DEALER_SEARCH_DISPLAY_ELEMENT_ID,
  ElementTypes,
  EventActions,
} from "@phn/utility/constants";
import { navContentStore } from "@phn/state/nav-content-store";
import { addRoute } from "@phn/services/routing-manager";
import analyticsManager from "../../../../shared/services/analytics/analytics-manager";
import { GlobalDataLayerService } from "../../../../shared/services/analytics/global-data-layer-service";
import {
  getDealerDetailsRoutingKey,
  RoutingKeys,
} from "../../../../shared/entities/routing-key";
import {
  PPNDealer,
  PPNDealerSearchResult,
} from "../../../../shared/entities/dealer-response";

export function DealerSearchFormItemCard({
  dealer,
  locale,
}: {
  dealer: PPNDealerSearchResult;
  showOverlay?: boolean;
  locale: string;
}): JSX.Element | null {
  return <phn-nd-dealer-card locale={locale} dealer={dealer} role="listitem" />;
}

export function onDealerCardClick(ppnDealer: PPNDealer) {
  const dealerDetailsTrackingKey = getDealerDetailsRoutingKey(
    ppnDealer.porschePartnerNo,
  );
  addRoute([ppnDealer.id]);

  const { dealer: dealerContent } = navContentStore.state;
  const { results, searchTerm } = dealerSearchResultsStore.state;

  GlobalDataLayerService.getInstance().pushDataLayerEvent(
    EventActions.DEALER_RESULT_CLICK,
    {
      componentClick: {
        clickElementId: ppnDealer.porschePartnerNo,
        clickElementName: ppnDealer.name,
        clickElementType: ClickElementTypes.Button,
        targetElement: `level2_${dealerDetailsTrackingKey}`,
      },
      componentDisplay: {
        displayElementId: DEALER_SEARCH_DISPLAY_ELEMENT_ID,
        displayElementType: analyticsManager.calculateDisplayElementType(
          RoutingKeys.DEALER_SEARCH,
          ElementTypes.dealerSearchForm,
        ),
        displayElementName: dealerContent.text,
      },
      componentSearch: {
        searchTerm,
        numberOfResults: results?.length,
      },
      partner: {
        companyName: ppnDealer.name,
        companyId: ppnDealer.porschePartnerNo,
      },
    },
  );
}
